import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './invoice.types';
import * as constants from './invoice.constants';

export const invoiceReducer = generateResourceReducer<types.IInvoice>({
  STORE: constants.STORE_INVOICE,
  CLEAR: constants.CLEAR_INVOICE,
});
